<template>
	<div class="sidebar-jon">
		<div class="sidebar-jon--avatar">
			<div>
				<Jon/>
				<div class="arrow-down"></div>
			</div>
			<div>Skilly hilft dir gerne weiter:</div>
		</div>
		<ul class="sidebar-jon--items">
			<li
				v-for="(message, i) in messages"
				:key="'message-' + i"
				:class="'sidebar-jon--item sidebar-jon--item-' + i"
			>
				<span v-html="message"/>
			</li>
		</ul>
	</div>
</template>

<script>
import Jon from "@/vue/common/image/Jon.vue";

export default {
	components: {Jon},

	props: {
		messages: {
			type: Array,
			required: true,
		}
	}
}
</script>
